import { SkeletonLoader } from "../SkeletonLoader";

type HeaderRowSkeletonProps = {
  labelWidth: number;
  valueWidth: number;
};

const HeaderRowSkeleton = ({
  labelWidth,
  valueWidth,
}: HeaderRowSkeletonProps) => (
  <div className="flex items-center gap-1 lg:min-w-0 lg:flex-1 lg:flex-col lg:items-stretch">
    <div className="flex min-w-0 flex-1 flex-col gap-2 lg:flex-none">
      <SkeletonLoader width={labelWidth} height={20} variant="rounded" />
      <div className="h-8 lg:h-12" style={{ maxWidth: valueWidth }}>
        <SkeletonLoader variant="rounded" />
      </div>
    </div>
    <div className="shrink-0">
      <SkeletonLoader width={80} height={20} variant="rounded" />
    </div>
  </div>
);

export const RebateTierWidgetSkeleton = () => (
  <div
    data-testid="rebate-tier-widget-skeleton"
    className="flex flex-col gap-6 rounded-2xl border border-stroke-primary bg-surface-primary p-6 lg:p-8"
  >
    <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
      <HeaderRowSkeleton labelWidth={96} valueWidth={160} />
      <div aria-hidden className="h-px w-full bg-stroke-primary lg:hidden" />
      <HeaderRowSkeleton labelWidth={72} valueWidth={200} />
    </div>
    <div className="flex flex-col gap-3">
      <SkeletonLoader height={8} variant="rounded" />
      <SkeletonLoader width={140} height={20} variant="rounded" />
    </div>
  </div>
);
